export default {
    methods: {
        getItem(url) {
            return new Promise((resolve, reject) => {
                this.$http.get(url)
                    .then(data => {
                        this.loading = false;
                        resolve(data);
                    }).catch(err => {
                        reject(err);
                    });
            });
        },
    }
}